export const findErrorOperator = (url: string): string => {
   switch (url) {
    case 'http://udacha.sz.kz':
      return 'beeline_ksell';
    case 'http://tvoya-udacha.tele2.kz':
      return 'tele2';
    case 'http://tvoya-udacha.altel.kz':
      return 'altel';
    default:
      return '';
  }
}